import { db } from '@/store/db';

export const INDEXEDB_STORAGE = 'INDEXEDB_STORAGE';
export const LOCALSTORAGE_STORAGE = 'LOCALSTORAGE_STORAGE';

class StorageUtil {
    /**
     * Prefixo para os nomes dos storages do sistema
     * @constant {string}
     */
    static PREFIXO_NOME_STORAGE = 'SE-';

    static setItem(store, json, type = LOCALSTORAGE_STORAGE) {
        if (json && type === INDEXEDB_STORAGE) {
            this.setIndexedDBStore(StorageUtil.PREFIXO_NOME_STORAGE + store, json);
        } else if (json) {
            localStorage.setItem(StorageUtil.PREFIXO_NOME_STORAGE + store, json);
        } else {
            StorageUtil.removeItem(store);
        }
    }

    static async getItem(store, type = LOCALSTORAGE_STORAGE) {
        if (type === INDEXEDB_STORAGE) {
            return await this.getIndexedDBStore(StorageUtil.PREFIXO_NOME_STORAGE + store);
        } else {
            return Promise.resolve(localStorage.getItem(StorageUtil.PREFIXO_NOME_STORAGE + store));
        }
    }

    static async setIndexedDBStore(store, json) {
        if (json) {
            await db.stores.put({ storeNome: store, conteudo: json });
        } else {
            await db.stores.where('storeNome').equalsIgnoreCase(store).delete();
        }
    }

    static async getIndexedDBStore(store) {
        const valorAtual = await db.stores.where('storeNome').equalsIgnoreCase(store).first();

        if (valorAtual) {
            return valorAtual.conteudo;
        }

        return null;
    }

    static async getObject(store, type = LOCALSTORAGE_STORAGE) {
        if (!store) {
            return null;
        }

        try {
            const item = await StorageUtil.getItem(store, type);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error(`Erro ao buscar storage [${store}]:`, error);
            await StorageUtil.removeItem(store, type);
            return null;
        }
    }

    /**
     * Remove uma storage local.
     *
     * @param {string | Object} store O nome da storage ou uma instância de {store.Store}
     */
    static async removeItem(store, type) {
        let storageName;

        if (typeof store === 'string' || store instanceof String) {
            storageName =
                store.indexOf(StorageUtil.PREFIXO_NOME_STORAGE) !== 0
                    ? StorageUtil.PREFIXO_NOME_STORAGE + store
                    : store;
        } else if (typeof store === 'object' || store instanceof Object) {
            if (store.nomeStorage !== undefined) {
                storageName =
                    store.nomeStorage.indexOf(StorageUtil.PREFIXO_NOME_STORAGE) !== 0
                        ? StorageUtil.PREFIXO_NOME_STORAGE + store.nomeStorage
                        : store.nomeStorage;
            }
        }

        if (storageName === undefined) {
            console.warn('Não foi possível identificar o nome da storage:', store);
            return;
        }

        console.log('Removendo storage ' + storageName + '...');

        if (type === INDEXEDB_STORAGE) {
            await db.stores.where('storeNome').equalsIgnoreCase(store).delete();
        } else if (json) {
            localStorage.removeItem(storageName);
        }
    }

    /**
     * Remove todas as storages locais.
     *
     * @param {Array.<string>} excecoes Lista de itens que não devem ser excluídos
     * @returns {number} O total de itens excluídos
     */
    static removeAll(excecoes) {
        let selecionadosParaExclusao = [];

        for (let i = 0; i < localStorage.length; i++) {
            // @ts-ignore
            if (localStorage.key(i) !== null && localStorage.key(i).indexOf(StorageUtil.PREFIXO_NOME_STORAGE) === 0) {
                if (!excecoes || !Array.isArray(excecoes) || !excecoes.includes(localStorage.key(i))) {
                    selecionadosParaExclusao.push(localStorage.key(i));
                } else {
                    console.log(localStorage.key(i) + ' não será removida.');
                }
            }
        }

        let itensRemovidos = 0;
        selecionadosParaExclusao.forEach((element) => {
            if (element) {
                console.log('Removendo storage ' + element + '...');
                localStorage.removeItem(element);
                itensRemovidos++;
            }
        });

        return itensRemovidos;
    }
}

export default StorageUtil;
